import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Tweet14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_231)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.51199 2.12399C1.37435 2.59864 1.32847 3.11094 1.33645 3.60258C1.34396 4.06502 1.41288 4.61904 1.62378 5.17665H0.777744C0.244095 5.17665 -0.124544 5.74456 0.0927086 6.23198C0.470326 7.0792 1.04779 7.82219 1.77557 8.39725C2.11438 8.66496 2.48106 8.89256 2.8682 9.07667C2.36869 9.40674 1.82787 9.67311 1.25811 9.86821C0.680368 10.066 0.578324 10.8675 1.08806 11.2038C2.28793 11.9954 3.69387 12.4171 5.1313 12.4167C6.08254 12.422 7.02553 12.24 7.90645 11.881C8.78813 11.5217 9.59034 10.992 10.2672 10.3224C10.944 9.65284 11.4823 8.85638 11.8511 7.97861C12.2199 7.10085 12.4121 6.15899 12.4166 5.2069C12.4166 4.95296 12.42 4.69878 12.4163 4.44487L14 2.3333L11.9182 2.85374C10.9044 1.34641 8.69683 1.13928 7.4186 2.41751C7.05375 2.78236 6.79514 3.2336 6.66268 3.72314C6.01086 3.67403 5.36981 3.52039 4.76443 3.26691C4.01932 2.90806 3.34559 2.41677 2.7761 1.81693C2.38963 1.40986 1.66897 1.58561 1.51199 2.12399ZM8.47926 3.47817C9.02915 2.92828 9.94855 2.92828 10.4984 3.47817C10.7662 3.74593 10.9166 4.10909 10.9166 4.48776V5.20148C10.9128 5.95585 10.7604 6.70207 10.4682 7.39756C10.1758 8.09358 9.74897 8.72512 9.21226 9.25608C8.67555 9.78704 8.03945 10.207 7.34032 10.4919C6.64119 10.7769 5.89275 10.9212 5.1378 10.9167L5.1328 10.9167C4.48791 10.9171 3.85097 10.8107 3.24687 10.605C3.85666 10.2538 4.42276 9.82788 4.93148 9.33565C5.36041 8.92064 5.13514 8.16989 4.54859 8.05957C3.87541 7.93297 3.24298 7.64499 2.70553 7.22032C2.49836 7.05662 2.30769 6.8745 2.1356 6.67665H2.95552C3.59905 6.67665 3.94274 5.88158 3.50185 5.41281C3.07803 4.96221 2.90211 4.40164 2.85191 3.86699C3.2545 4.15771 3.68312 4.41244 4.13295 4.62765C4.14351 4.63271 4.15419 4.63751 4.16499 4.64207C5.16594 5.06455 6.24582 5.26758 7.33186 5.23748C7.73782 5.22622 8.06108 4.89388 8.06108 4.48776C8.06108 4.10909 8.2115 3.74593 8.47926 3.47817Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_231'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Tweet14.displayName = 'Tweet14';
export default Tweet14;
